import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

/**
 * 🗓️ Página de Agenda del Calendario
 */
const CalendarAgenda = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">
          Agenda del Día
        </h2>

        <p className="text-gray-600 dark:text-gray-400">
          Aquí se visualizará la agenda diaria con las tareas, eventos o
          compromisos del usuario. Desde aquí se podrá gestionar o modificar
          los elementos agendados.
        </p>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default CalendarAgenda;
